import React from "react"
import { useStaticQuery, Link, graphql } from "gatsby"

import BackgroundImage from "gatsby-background-image"
import ServiceLink from "./ServiceLink"
import SectionTitle from "../SectionTitle"
import ContactForm from "../contactForm"

// Parameters include the image for the BackgroundImage component

const IndexTopContainer = ({ fluid }) => {
  const data = useStaticQuery(graphql`
    query topContainerQuery {
      plumbingIconUrl: allFile(filter: { name: { eq: "Plumbing2" } }) {
        edges {
          node {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
      heatingIconUrl: allFile(filter: { name: { eq: "Heating" } }) {
        edges {
          node {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
      gasIconUrl: allFile(filter: { name: { eq: "Gas-Fitting" } }) {
        edges {
          node {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
      serviceDescriptions: allSanityHomePage {
        edges {
          node {
            gasfittingDescription
            plumbingDescription
            heatingDescription
          }
        }
      }
    }
  `)

  const plumbingIcon = data.plumbingIconUrl.edges[0].node.childImageSharp.fluid
  const plumbingDescription =
    data?.serviceDescriptions?.edges[0]?.node?.plumbingDescription || null
  const gasfittingDescription =
    data?.serviceDescriptions?.edges[0]?.node?.gasfittingDescription || null
  const heatingDescription =
    data?.serviceDescriptions?.edges[0]?.node?.heatingDescription
  const heatingIcon = data.heatingIconUrl.edges[0].node.childImageSharp.fluid
  const gasIcon = data.gasIconUrl.edges[0].node.childImageSharp.fluid

  return (
    <BackgroundImage fluid={fluid}>
      <div className="indexPage__topContainer">
        {/* Top half of content */}
        <div className="indexPage__topContent">
          {/* Grid section 1 */}
          <div>
            <div className="indexPage__tagLineContainer">
              <h1 className="indexPage__tagLine">
                Serving Calgary and Cochrane, Alberta
                <br />
                <span className="settings__textHighlight">Since 2005</span>
              </h1>
            </div>
            <div className="indexPage__tagLineButtonContainer">
              <Link
                to="/#what-we-do"
                className="settings__mainButton indexPage__tagLineButton"
              >
                Our Services
              </Link>
            </div>
          </div>
          {/* Grid section 1 -- END */}

          {/* Grid section 2 */}

          <div className="indexPage__formOuterContainer">
            <div className="indexPage__formInnerContainer">
              <h2 style={{ textAlign: "center" }}>Schedule Service</h2>

              <ContactForm />
            </div>
          </div>

          {/* Grid section 2 -- END */}
        </div>

        {/* Bottom half of content */}
        <div className="indexPage__whatWeDo" id="what-we-do">
          <SectionTitle className="indexPage__whatWeDoTitle">
            <span
              style={{
                borderTop: "solid white  1px",
                paddingTop: 12,
              }}
            >
              What <span style={{ color: "rgb(245, 192, 7)" }}>We</span> Do
            </span>
          </SectionTitle>

          <div className="indexPage__whatWeDoLinks">
            {plumbingDescription && plumbingIcon ? (
              <ServiceLink
                icon={plumbingIcon}
                alt="plumbing"
                name="Plumbing"
                url="/plumbing"
                description={plumbingDescription}
              />
            ) : null}

            {heatingDescription && heatingIcon ? (
              <ServiceLink
                icon={heatingIcon}
                alt="heating"
                name="Heating"
                url="/heating"
                description={heatingDescription}
              />
            ) : null}

            {gasfittingDescription && gasIcon ? (
              <ServiceLink
                icon={gasIcon}
                alt="gasfitting"
                name="Gasfitting"
                url="/gasfitting"
                description={gasfittingDescription}
              />
            ) : null}
          </div>
        </div>
      </div>
    </BackgroundImage>
  )
}

export default IndexTopContainer
